import { render, staticRenderFns } from "./ShiftsList.vue?vue&type=template&id=8c5ce3ba&scoped=true&"
import script from "./ShiftsList.vue?vue&type=script&lang=js&"
export * from "./ShiftsList.vue?vue&type=script&lang=js&"
import style0 from "./ShiftsList.vue?vue&type=style&index=0&id=8c5ce3ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5ce3ba",
  null
  
)

export default component.exports